import React from "react";
import { Outlet, useOutletContext } from 'react-router-dom';
import { ComputerDesktopIcon } from "@heroicons/react/20/solid";

import Breadcrumb from "../../../../components/navigation/Breadcrumb";
import TabBar from "../../../../components/navigation/TabBar";

const tabs = [
  { name: "Details", to: "details" },
  { name: "Advertorial UI", to: "advertorial-ui" },
  { name: "Advertorial Hosting", to: "advertorial-hosting" },
  { name: "Rate card", to: "rate-card" },
]

const Website = () => {
  const { website } = useOutletContext<any>();


  const pages = [
    { name: website.name, current: false },
  ]

  return (
    <>
      <Breadcrumb className="mb-3" pages={pages} rootPage={{href: '/settings/websites', Icon: ComputerDesktopIcon, screenReaderText: 'Websites'}} />

      <TabBar tabs={tabs} />

      <Outlet context={{ website }} />
    </>
  )
};

export default Website;
